import React from "react";
import classnames from "classnames";
import { ButtonSpan } from "../../Button";

export const snapshotAvailableMetrics = [
  { key: "event_count", label: "All Events Count", filter: "all" },
  { key: "event_value", label: "All Events Value", filter: "all" },
  {
    key: "confirmed_event_count",
    label: "Confirmed Events Count",
    filter: "confirmed",
  },
  {
    key: "confirmed_event_value",
    label: "Confirmed Events Value",
    filter: "confirmed",
  },
  { key: "commission_value", label: "Commission Value", filter: "confirmed" },
  { key: "commission_rate", label: "Commission Rate %", filter: "confirmed" },
  {
    key: "total_cost_savings_percentage",
    label: "Cost Savings %",
    filter: "confirmed",
  },
  { key: "conversion_rate", label: "Conversion Rate (%)", filter: "confirmed" },
];

export const ToggleMetricSelector = ({
  selectedMetric,
  onChange,
  setFilter,
}) => {
  return (
    <div className="flex flex-wrap gap-2 text-base font-bold mb-4">
      {snapshotAvailableMetrics.map(({ key, label, filter }) => (
        <ButtonSpan
          key={key}
          className={classnames("my-1 px-3 py-1 border border-grey-md", {
            "bg-brand text-white": selectedMetric === key,
            "opacity-50": selectedMetric !== key,
          })}
          onClick={() => {
            onChange(key);
            setFilter(filter);
          }}
        >
          {label}
        </ButtonSpan>
      ))}
    </div>
  );
};
